// Lot classification thresholds — mirror of the backend constants in
// services/exportersvc/usinage/rules.go. The backend is the source of
// truth; the FE only uses these for live previews ("this will become a
// LOT" / "this will become a Queue de Lot") before submit.
export const LOT_TARGET_BAGS = 385
export const STANDARD_BAG_TARE_KG = 0.67
export const LOT_MIN_NET_KG = 24_500
export const LOT_MAX_NET_KG = 25_500

export type LotKindPreview = "FULL" | "QUEUE"

// classifyLot returns the kind the backend will stamp on a freshly
// fabricated lot for the given measured bag count and net weight (kg).
// FULL requires bags exactly at the target AND weight inside the
// acceptance window; anything else is a Queue de Lot.
export function classifyLot(bags: number, netKg: number): LotKindPreview {
  if (
    bags === LOT_TARGET_BAGS &&
    netKg >= LOT_MIN_NET_KG &&
    netKg <= LOT_MAX_NET_KG
  ) {
    return "FULL"
  }
  return "QUEUE"
}
